import React from 'react';
import { useAuth } from '../context/AuthContext';

const ikonlar = {
  talep: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"/></svg>,
  liste: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M4 6h16M4 10h16M4 14h16M4 18h16"/></svg>,
  kullanici: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2M9 11a4 4 0 100-8 4 4 0 000 8zM23 21v-2a4 4 0 00-3-3.87M16 3.13a4 4 0 010 7.75"/></svg>,
  belge: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M19 21H5a2 2 0 01-2-2V5a2 2 0 012-2h11l5 5v11a2 2 0 01-2 2z"/><polyline points="17 21 17 13 7 13 7 21"/><polyline points="7 3 7 8 15 8"/></svg>,
  bordro: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>,
  log: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/><polyline points="10 9 9 9 8 9"/></svg>,
  sirket: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/></svg>,
  mail: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg>,
  rol: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>,
  musteri: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z"/></svg>,
  org: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="9" y="2" width="6" height="4" rx="1"/><rect x="2" y="18" width="6" height="4" rx="1"/><rect x="9" y="18" width="6" height="4" rx="1"/><rect x="16" y="18" width="6" height="4" rx="1"/><path d="M12 6v4M5 18v-4h14v4M12 10v4"/></svg>,
  pozisyon: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M20 7H4a2 2 0 00-2 2v6a2 2 0 002 2h16a2 2 0 002-2V9a2 2 0 00-2-2z"/><path d="M16 21V5a2 2 0 00-2-2h-4a2 2 0 00-2 2v16"/></svg>,
  chevron: (acik) => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" style={{width:'14px',height:'14px',transform:acik?'rotate(180deg)':'rotate(0deg)',transition:'transform 0.2s'}}><polyline points="6 9 12 15 18 9"/></svg>
};

const modulIkon = (anahtar) => {
  const map = {
    'yeni-talep': ikonlar.talep, 'taleplerim': ikonlar.liste, 'talepler': ikonlar.liste,
    'bordro-yukle': ikonlar.bordro, 'standart-belgeler': ikonlar.belge, 'sablon-yonetimi': ikonlar.belge,
    'hr-adaylar': ikonlar.kullanici, 'personel-listesi': ikonlar.kullanici, 'yeni-personel': ikonlar.kullanici,
    'vize-talepler-hr': ikonlar.talep, 'izin-onay': ikonlar.bordro, 'izin-taleplerim': ikonlar.bordro,
    'kullanicilar': ikonlar.kullanici, 'rol-yonetimi': ikonlar.rol, 'mail-ayarlari': ikonlar.mail,
    'mail-sablonlari': ikonlar.mail, 'sistem-loglari': ikonlar.log, 'sirket-bilgileri': ikonlar.sirket,
    'icerik-yonetimi': ikonlar.belge, 'kisisel-bilgiler': ikonlar.kullanici,
    'aday-bilgileri': ikonlar.kullanici, 'aday-paneli': ikonlar.talep,
    'musteriler': ikonlar.musteri, 'organizasyon': ikonlar.org,
    'org-departman': ikonlar.org, 'org-pozisyon': ikonlar.pozisyon,
    'kadro-talepleri': ikonlar.liste, 'egitim-yonetimi': ikonlar.belge,
    'egitim-raporu': ikonlar.liste, 'belge-yonetimi': ikonlar.belge,
    'yonetim-dashboard': ikonlar.liste, 'egitimlerim': ikonlar.belge,
    'masraf-taleplerim': ikonlar.talep, 'masraf-yonetimi': ikonlar.talep,
    'zimmet-yonetimi': ikonlar.belge, 'onay-bekleyenlerim': ikonlar.bordro,
    'onay-akis-yonetimi': ikonlar.rol,
  };
  return map[anahtar] || ikonlar.belge;
};

const rolEtiketi = {
  personel: 'Personel', muhasebeci: 'Muhasebeci', admin: 'Admin',
  hr: 'IK Uzmani', hr_super: 'HR Super', yonetici: 'Yonetici', aday: 'Aday'
};

const Sidebar = ({ aktifSayfa, sayfaDegistir }) => {
  const { kullanici, cikisYap, modulYetkileri } = useAuth();
  const initials = kullanici ? (kullanici.ad[0] + kullanici.soyad[0]).toUpperCase() : 'KK';
  const [acikGruplar, setAcikGruplar] = React.useState({});
  const [acikAltGruplar, setAcikAltGruplar] = React.useState({});
  const [mobilAcik, setMobilAcik] = React.useState(false);

  const toggleGrup = (g) => setAcikGruplar(p => ({ ...p, [g]: !p[g] }));
  const toggleAltGrup = (key) => setAcikAltGruplar(p => ({ ...p, [key]: !p[key] }));
  const sayfaDegistirVeKapat = (sayfa) => { sayfaDegistir(sayfa); setMobilAcik(false); };

  React.useEffect(() => {
    if (!aktifSayfa || !modulYetkileri || modulYetkileri.length === 0) return;
    const bulunan = modulYetkileri.find(m => m.anahtar === aktifSayfa);
    if (bulunan) {
      const g = bulunan.grup || 'Genel';
      setAcikGruplar(p => ({ ...p, [g]: true }));
      if (bulunan.alt_grup) {
        const key = g + '||' + bulunan.alt_grup;
        setAcikAltGruplar(p => ({ ...p, [key]: true }));
      }
    }
  }, [aktifSayfa, modulYetkileri]);

  const grupla = (moduller) => {
    const grupSiraMap = {};
    const grupModuller = {};
    (moduller || []).forEach(m => {
      const g = m.grup || 'Genel';
      const s = typeof m.grup_sira === 'number' ? m.grup_sira : 99;
      if (!(g in grupSiraMap) || s < grupSiraMap[g]) grupSiraMap[g] = s;
      if (!grupModuller[g]) grupModuller[g] = [];
      grupModuller[g].push(m);
    });
    return Object.keys(grupSiraMap).sort((a, b) => grupSiraMap[a] - grupSiraMap[b]).map(baslik => ({ baslik, menuler: grupModuller[baslik] || [] }));
  };

  const renderFooter = () => (
    <div className="sidebar-footer">
      <div className="kullanici-bilgi">
        <div className="avatar">{initials}</div>
        <div className="kullanici-bilgi-yazi">
          <p>{kullanici?.ad} {kullanici?.soyad}</p>
          <span>{rolEtiketi[kullanici?.rol] || kullanici?.rol}</span>
        </div>
      </div>
      <button className="cikis-btn" onClick={() => cikisYap()}>Cikis Yap</button>
    </div>
  );

  const renderGrupIcerigi = (grup) => {
    const altGrupMap = {};
    const direkt = [];

    grup.menuler.forEach(m => {
      if (m.alt_grup) {
        if (!altGrupMap[m.alt_grup]) altGrupMap[m.alt_grup] = [];
        altGrupMap[m.alt_grup].push(m);
      } else {
        direkt.push(m);
      }
    });

    const altGrupVar = Object.keys(altGrupMap).length > 0;

    return (
      <div style={{ paddingLeft: '4px' }}>
        {/* Direkt modüller */}
        {direkt.map(m => (
          <button key={m.anahtar}
            className={"nav-item " + (aktifSayfa === m.anahtar ? 'aktif' : '')}
            onClick={() => sayfaDegistirVeKapat(m.anahtar)}>
            {modulIkon(m.anahtar)}{m.baslik}
          </button>
        ))}
        {/* Alt gruplar */}
        {Object.keys(altGrupMap).map(altGrup => {
          const key = grup.baslik + '||' + altGrup;
          const acik = acikAltGruplar[key];
          return (
            <div key={altGrup} style={{ marginBottom: '2px' }}>
              <button onClick={() => toggleAltGrup(key)}
                style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%', padding: '0.4rem 0.75rem', border: 'none', background: 'none', cursor: 'pointer', fontSize: '11px', fontWeight: '600', color: 'var(--yazi-ikincil)', letterSpacing: '0.05em', borderRadius: 'var(--radius-sm)', opacity: 0.8 }}>
                <span style={{ fontSize: '11px', color: 'var(--yazi-ikincil)' }}>— {altGrup}</span>
                {ikonlar.chevron(acik)}
              </button>
              {acik && (
                <div style={{ paddingLeft: '8px' }}>
                  {altGrupMap[altGrup].map(m => (
                    <button key={m.anahtar}
                      className={"nav-item " + (aktifSayfa === m.anahtar ? 'aktif' : '')}
                      onClick={() => sayfaDegistirVeKapat(m.anahtar)}>
                      {modulIkon(m.anahtar)}{m.baslik}
                    </button>
                  ))}
                </div>
              )}
            </div>
          );
        })}
      </div>
    );
  };

  const renderDBMenu = (moduller) => {
    const gruplar = grupla(moduller);
    if (gruplar.length <= 1) {
      return (
        <nav className="sidebar-nav">
          {(moduller || []).map(m => (
            <button key={m.anahtar}
              className={"nav-item " + (aktifSayfa === m.anahtar ? 'aktif' : '')}
              onClick={() => sayfaDegistirVeKapat(m.anahtar)}>
              {modulIkon(m.anahtar)}{m.baslik}
            </button>
          ))}
        </nav>
      );
    }
    return (
      <nav className="sidebar-nav" style={{ gap: '0' }}>
        {gruplar.map(grup => (
          <div key={grup.baslik} style={{ marginBottom: '4px' }}>
            <button onClick={() => toggleGrup(grup.baslik)}
              style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%', padding: '0.5rem 0.75rem', border: 'none', background: 'none', cursor: 'pointer', fontSize: '11px', fontWeight: '600', color: 'var(--yazi-ikincil)', textTransform: 'uppercase', letterSpacing: '0.08em', borderRadius: 'var(--radius-sm)' }}>
              <span>{grup.baslik}</span>
              {ikonlar.chevron(acikGruplar[grup.baslik])}
            </button>
            {acikGruplar[grup.baslik] && renderGrupIcerigi(grup)}
          </div>
        ))}
      </nav>
    );
  };

  const HamburgerBtn = () => (
    <button className="hamburger-btn" onClick={() => setMobilAcik(!mobilAcik)}>
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        {mobilAcik
          ? <><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></>
          : <><line x1="3" y1="6" x2="21" y2="6"/><line x1="3" y1="12" x2="21" y2="12"/><line x1="3" y1="18" x2="21" y2="18"/></>
        }
      </svg>
    </button>
  );

  if (kullanici?.rol === 'aday') {
    return (
      <>
        <HamburgerBtn />
        <div className={"sidebar-overlay" + (mobilAcik ? ' aktif' : '')} onClick={() => setMobilAcik(false)} />
        <aside className={"sidebar" + (mobilAcik ? ' mobil-acik' : '')} style={{ display: 'flex', flexDirection: 'column' }}>
          <div className="sidebar-logo"><h2>Valure HR</h2></div>
          <div style={{ flex: 1, overflowY: 'auto' }}>
            <nav className="sidebar-nav">
              <button className={"nav-item " + (aktifSayfa === 'aday-bilgileri' ? 'aktif' : '')} onClick={() => sayfaDegistirVeKapat('aday-bilgileri')}>{ikonlar.kullanici}Bilgilerim</button>
              <button className={"nav-item " + (aktifSayfa === 'aday-paneli' ? 'aktif' : '')} onClick={() => sayfaDegistirVeKapat('aday-paneli')}>{ikonlar.talep}Basvuru Surecim</button>
            </nav>
          </div>
          {renderFooter()}
        </aside>
      </>
    );
  }

  return (
    <>
      <HamburgerBtn />
      <div className={"sidebar-overlay" + (mobilAcik ? ' aktif' : '')} onClick={() => setMobilAcik(false)} />
      <aside className={"sidebar" + (mobilAcik ? ' mobil-acik' : '')} style={{ display: 'flex', flexDirection: 'column' }}>
        <div className="sidebar-logo"><h2>Valure HR</h2></div>
        <div style={{ flex: 1, overflowY: 'auto' }}>
          {modulYetkileri && modulYetkileri.length > 0
            ? renderDBMenu(modulYetkileri)
            : <div style={{ padding: '1rem', color: 'var(--yazi-ikincil)', fontSize: '13px' }}>Yukleniyor...</div>
          }
        </div>
        {renderFooter()}
      </aside>
    </>
  );
};

export default Sidebar;
